import React, { useEffect, useState } from "react";

import DataTable from "../../../../../../Common/DataTable/DataTable";
import DataTableHeader from "../../../../../../Common/DataTableHeader/DataTableHeader";
import DataTableFooter from "../../../../../../Common/DataTableFooter/DataTableFooter";
import { cleaningReportColumn } from "./CleaningReportTableData";
import api from "../../../../../../api/axios";

const CleaningReportTable = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadReport();
  }, []);

  const loadReport = async () => {
    try {
      setLoading(true);

      const hkRes = await api.get("/pms/housekeeping");
      const userRes = await api.get("/users");

      const logs = hkRes.data ?? [];
      const users = userRes.data ?? [];

      // STEP 1: Group logs by room_id to get only latest per room
      const latestLogsByRoom = {};

      logs.forEach((log) => {
        const roomId = log.room_id;

        if (
          !latestLogsByRoom[roomId] ||
          new Date(log.created_at) >
            new Date(latestLogsByRoom[roomId].created_at)
        ) {
          latestLogsByRoom[roomId] = log;
        }
      });

      // Convert object → array
      const latestLogs = Object.values(latestLogsByRoom);

      // STEP 2: Group latest room logs by user
      const groupedByUser = {};

      latestLogs.forEach((log) => {
        const userId = log.assigned_to_user_id;
        if (!groupedByUser[userId]) groupedByUser[userId] = [];
        groupedByUser[userId].push(log);
      });

      // STEP 3: Build report rows
      const reportRows = Object.entries(groupedByUser).map(([userId, logs]) => {
        const user = users.find((u) => u.id == userId);

        return {
          id: userId,
          empName: user?.name ?? "Unknown",

          // ⭐ FINAL FIX: count based ONLY on the latest log
          complete: logs.filter((l) => l.status === "inspected").length,
          underProcess: logs.filter((l) => l.status === "cleaning").length,
          pending: logs.filter(
            (l) => l.status === "dirty" || l.status === "dirty_assigned"
          ).length,
        };
      });

      setRows(reportRows);
    } catch (err) {
      console.log("Error loading data:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <DataTableHeader />

      {loading ? (
        <div className="text-center py-4">
          <div className="spinner-border text-primary"></div>
        </div>
      ) : (
        <DataTable columns={cleaningReportColumn} data={rows} />
      )}

      {/* <DataTableFooter dataT={rows} /> */}
    </>
  );
};

export default CleaningReportTable;
